// Static data: known Android process and tag names used to seed the
// FilterBar's autocomplete suggestions. Lives in its own tiny module
// so it can be statically imported even when the heavyweight log
// generator (`logGenerator.ts`) is lazy-loaded.

export const KNOWN_PROCESSES: readonly string[] = [
  'com.android.systemui',
  'system_server',
  'com.google.android.gms',
  'com.android.vending',
  'com.example.shopapp',
  'com.example.shopapp:remote',
  'com.android.chrome',
  'com.spotify.music',
  'com.android.bluetooth',
  'com.google.android.inputmethod.latin',
];

export const KNOWN_TAGS: readonly string[] = [
  'StatusBar',
  'NotifManager',
  'KeyguardUpdateMonitor',
  'BatteryController',
  'QSPanel',
  'ActivityManager',
  'ActivityTaskManager',
  'WindowManager',
  'PowerManagerService',
  'AlarmManager',
  'JobScheduler',
  'PackageManager',
  'ConnectivityService',
  'GmsCore',
  'Auth',
  'Wearable',
  'Reachability',
  'Finsky',
  'PlayCore',
  'AssetModuleService',
  'MainActivity',
  'CartViewModel',
  'ApiClient',
  'ImageLoader',
  'Choreographer',
  'OkHttp',
  'Retrofit',
  'Glide',
  'Room',
  'RemoteWorker',
  'SyncAdapter',
  'chromium',
  'cr_BindingManager',
  'cr_TabState',
  'AudioPlayer',
  'SpotifyService',
  'PlaybackController',
  'BtService',
  'GattClient',
  'A2dp',
  'LatinIME',
  'KeyboardSwitcher',
];
